module.exports = __webpack_public_path__ + "img/user-minus.a5289ee0.svg";